module.exports = __webpack_public_path__ + "static/img/header6.403f162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header6.jpg
// module id = iXIU
// module chunks = 1